import React from "react";
import { config } from "../config";
import { Link } from "react-router-dom";
import { useInView } from "react-intersection-observer";

const AboutSection = () => {

  return (
    <>
      <section class="values container">
        <div class="values__item">
          <div class="values__icon">✨</div>
          <h4>Handcrafted</h4>
          <p>Every piece at Maa vaishno jewellers is meticulously handcrafted by skilled artisans, preserving generations of tradition.</p>
        </div>
        <div class="values__item">
          <div class="values__icon">💍</div>
          <h4>Pure & Hallmarked</h4>
          <p>We offer BIS hallmarked gold and certified jewellery, ensuring purity, authenticity, and complete trust in every purchase.</p>
        </div>
        <div class="values__item">
          <div class="values__icon">📿</div>
          <h4>Certified Diamonds</h4>
          <p>Our diamonds and gemstones are carefully selected and certified, delivering unmatched brilliance, quality, and lasting.</p>
        </div>
        <div class="values__item">
          <div class="values__icon">💎</div>
          <h4>Custom Jewellery</h4>
          <p>Bring your vision to life with our bespoke jewellery services, where every design is uniquely crafted to tell your story.</p>
        </div>
      </section>
    </>
  );
};

export default AboutSection;
